import { IncomingMessage } from "http";
import { configureNextServerRequest } from "@repo/next-utils/next-server-request";
import { BUILD_NUMBER, APP_ENVIRONMENT } from "@/constants";

type PageRouterServerRequestConstructorOptions = {
  req: IncomingMessage;
};

export const configurePageRouterServerRequest = (
  options: PageRouterServerRequestConstructorOptions,
) => {
  const { req } = options;
  const protocol = req.headers["x-forwarded-proto"] || "http";
  const host = req.headers.host;
  const fullUrl = `${protocol}://${host}${req.url}`;

  const cookies: Record<string, string> = Object.fromEntries(
    (req.headers.cookie || "")
      .split("; ")
      .map((c) => c.split("="))
      .filter(([k, v]) => k && v),
  );

  const headers: Record<string, string> = Object.fromEntries(
    Object.entries(req.headers).map(([k, v]) => [k, String(v)]),
  );

  return configureNextServerRequest({
    clientName: "Asos.Web.Topshop.Server",
    clientVersion: BUILD_NUMBER || "local",
    defaultTimeout: 10_000,
    defaultRetries: 2,
    defaultRetryDelay: 2000,
    getXSiteOrigin: async () => {
      if (APP_ENVIRONMENT === "prod") {
        return null;
      }

      // Retrieve x-site-origin from query string, header then cookies
      const queryParams = new URL(fullUrl).searchParams;
      const xSiteOriginFromQuery = queryParams.get("x-site-origin");
      const xSiteOriginFromHeader = headers["x-site-origin"];
      const xSiteOriginCookie = cookies["x-site-origin"] || "";
      return (
        xSiteOriginFromQuery ||
        xSiteOriginFromHeader ||
        xSiteOriginCookie ||
        null
      );
    },
  });
};
